import e from"styled-components";const t=e.div`
	border-radius: ${({borderRadius:e})=>e}px;
	border: ${({theme:e})=>`1px solid ${e.border.black10}`};
	background: ${({theme:e})=>e.bg.general};
	box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.2);
	height: 100%;
	display: grid;
	align-items: center;
	grid-template-columns: minmax(40px, 124px) auto;
	column-gap: 24px;
	padding-right: 16px;
`,i=e.div`
	background: url(${({imageUrl:e})=>e});
	background-size: cover;
	background-position: ${({position:e})=>e?`${e.x}% ${e.y}%`:"center"};
	position: relative;
	border-top-left-radius: ${({borderRadius:e})=>`${e}px`};
	border-bottom-left-radius: ${({borderRadius:e})=>`${e}px`};
	height: 100%;
	width: 100%;
`,o=e.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	column-gap: 8px;
	padding-block: 24px;
`,r=e.div`
	display: flex;
	flex-direction: column;
	row-gap: 4px;
`,d=e.h1`
	all: unset;
	color: ${({theme:e})=>e.text.text};
	font-size: 16px;
	font-weight: 700;
	line-height: 20px;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,p=e.p`
	all: unset;
	color: ${({theme:e})=>e.border.black50};
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,a=e.div`
	width: 24px;
	height: 24px;
`;export{a as ArrowContainer,t as CardContainer,o as CardContentContainer,i as CardImageContainer,r as CardTextContainer,p as Text,d as Title};
